import Swal from 'sweetalert2';
import { isNetworkError, NETWORK_ERROR_MESSAGE } from './networkError';

const swalConfirmButtonOptions = {
    buttonsStyling: false,
    customClass: {
        confirmButton: 'swal-vuetify-btn swal-btn-primary'
    }
};

export function showSwlLoading(text = '') {
    Swal.fire({
        title: '¡Espere por favor!',
        html: `<i class="fa fa-spin fa-spinner"></i><p>(${text})</p>`,
        allowOutsideClick: false,
        showConfirmButton: false
    });
}

export function closeSwlLodiang() {
    Swal.close();
}

export function showSwlLoadingError(text = '', allowOutsideClick = true) {
    Swal.fire({
        icon: 'error',
        title: '¡Lo sentimos!',
        text: text,
        ...swalConfirmButtonOptions,
        allowOutsideClick,
        allowEscapeKey: allowOutsideClick
    });
}

export function showSwlLoadingInfo(text = '', allowOutsideClick = true) {
    Swal.fire({
        icon: 'info',
        text: text,
        ...swalConfirmButtonOptions,
        allowOutsideClick,
        allowEscapeKey: allowOutsideClick
    });
}

export function showSuccess(text = '', allowOutsideClick = true) {
    Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: text,
        ...swalConfirmButtonOptions,
        allowOutsideClick: allowOutsideClick,
        allowEscapeKey: allowOutsideClick
    });
}

export function showAlert(text = '', allowOutsideClick = true) {
    Swal.fire({
        position: 'top-center',
        icon: 'success',
        text: text,
        showConfirmButton: false,
        timer: 1500,
        allowOutsideClick,
        allowEscapeKey: allowOutsideClick
    });
}

export async function showApiError(apiUrl, responseObj, errorObj, allowOutsideClick = true) {
    let url;
    let errorMessage = 'Error';
    let statusMessage;

    if (apiUrl) {
        const splitApiUrl = apiUrl.split('/');
        url = `${splitApiUrl[splitApiUrl.length - 2]}/${splitApiUrl[splitApiUrl.length - 1]}`;
    }

    if (responseObj) {
        if (responseObj?.message?.error) {
            errorMessage = `${responseObj?.message?.error}`;
            url = '';
        } else if (responseObj?.message) {
            errorMessage = `${responseObj?.message}`;
            url = '';
        } else if (responseObj?.response?.message) {
            errorMessage = `${responseObj.response.message}`;
            url = '';
        } else if (responseObj?.error?.message) {
            errorMessage = `${responseObj.error.message}`;
            url = '';
        } else if (responseObj?.error) {
            errorMessage = `${responseObj.error}`;
            url = '';
        } else {
            errorMessage = 'Hubo un problema.';
            statusMessage = `Estatus: ${responseObj.status}`;
        }
    } else if (errorObj) {
        if (isNetworkError(errorObj)) {
            // Sin conexión no tiene caso mostrar el endpoint técnico (p. ej. users/get_agents).
            errorMessage = NETWORK_ERROR_MESSAGE;
            url = '';
        } else if (errorObj?.message) {
            errorMessage = `${errorObj.message}`;
        }
    }

    await Swal.fire({
        icon: 'error',
        title: '¡Lo sentimos!',
        html: `<h5>${url || ''}</h5>
          <p>${errorMessage}</p>
          <p>${statusMessage || ''}</p>`,
        ...swalConfirmButtonOptions,
        allowOutsideClick,
        allowEscapeKey: allowOutsideClick
    });
}
